(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cm-cart-upsells"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.cmCartUpsells) {
      window.cmCartUpsells.render();
      return;
    }

    const fixed = ['dulces-de-miel-5o-unidades', 'bandeja-panelitas', 'miel-330-gr'];
    const care = ['crema-de-manos-apitoxina-y-lavanda', 'serum-de-apitoxina-para-el-cuello-y-rostro', 'gel-apitoxina-1'];
    const sprays = ['spray-de-propoleo-nasal', 'spray-de-propoleo-para-la-garganta'];
    const pantry = ['arequipe-grande', 'cafe-organico-de-confines', 'cafe-organico-de-paramo', 'cafe-organico-de-suaita-sabor-artesanal-de-altura'];
    const hive = ['propoleo-natural', 'polen-de-abeja-250-gr'];
    const capsules = 'capsulas-de-oregano-y-coco-oreco';
    const candles = 'velas-de-cera-de-abeja';
    const groups = new Map();
    care.concat(sprays, [capsules]).forEach(handle => groups.set(handle, ['bienestar']));
    pantry.concat([fixed[1]]).forEach(handle => groups.set(handle, ['artesanales']));
    pantry.slice(1).forEach(handle => groups.set(handle, ['artesanales', 'cafes']));
    hive.concat([fixed[2], candles]).forEach(handle => groups.set(handle, ['de-la-colmena']));
    groups.set(fixed[0], ['de-la-colmena', 'cafes']);

    function related(handle) {
      if (care.includes(handle)) return care;
      if (sprays.includes(handle)) return sprays.concat(hive);
      if (handle === capsules) return [hive[1], hive[0]];
      if (hive.includes(handle) || handle === fixed[2]) return hive.concat(pantry.slice(1));
      if (pantry.includes(handle) || handle === fixed[0] || handle === fixed[1]) return pantry;
      if (handle === candles) return hive.concat(pantry);
      return [];
    }

    function choose(catalog, cart) {
      const items = cart && Array.isArray(cart.items) ? cart.items.filter(item => Number(item.quantity) > 0) : [];
      if (!items.length) return [];
      const present = new Set(items.map(item => String(item.product_id)));
      const context = items.map(item => {
        const product = catalog.find(candidate => candidate.id === String(item.product_id));
        return item.handle || (product && product.handle) || '';
      }).filter(Boolean);
      const mainContext = context.filter(handle => !fixed.includes(handle));
      const preferredContext = mainContext.length ? mainContext : context;
      const available = catalog.filter(product => !present.has(product.id));
      const selected = fixed.map(handle => available.find(product => product.handle === handle)).filter(Boolean);

      function affinity(product, handles) {
        return handles.reduce((best, handle) => {
          const position = related(handle).indexOf(product.handle);
          const explicit = position < 0 ? 0 : 10000 - position * 1000;
          const sourceGroups = groups.get(handle) || [];
          const shared = product.groups.filter(group => sourceGroups.includes(group)).length * 50;
          return Math.max(best, explicit + shared);
        }, 0);
      }

      const replacements = available.filter(product => !fixed.includes(product.handle)).map((product, index) => ({
        product,
        index,
        score: affinity(product, preferredContext) * 100000 + affinity(product, context)
      })).sort((a, b) => b.score - a.score || a.index - b.index);
      replacements.forEach(({ product }) => {
        if (selected.length < 3 && !selected.some(candidate => candidate.id === product.id)) selected.push(product);
      });
      return selected.slice(0, 3).map(product => product.id);
    }

    let lastCart = null;
    function render(cart) {
      if (cart && Array.isArray(cart.items)) lastCart = cart;
      document.querySelectorAll('[data-cm-cart-upsells]').forEach(root => {
        if (!lastCart) {
          try {
            lastCart = JSON.parse(root.querySelector('[data-cm-upsell-initial-cart]').textContent);
          } catch (_) {
            return;
          }
        }
        const cards = Array.from(root.querySelectorAll('[data-cm-upsell-card]'));
        const catalog = cards.map(card => {
          let productGroups = [];
          try {
            productGroups = JSON.parse(card.dataset.cmProductGroups || '[]');
          } catch (_) {}
          return { id: card.dataset.cmProductId, handle: card.dataset.cmProductHandle, groups: productGroups };
        });
        const chosen = choose(catalog, lastCart);
        cards.forEach(card => {
          const position = chosen.indexOf(card.dataset.cmProductId);
          const hidden = position === -1;
          if (card.hidden !== hidden) card.hidden = hidden;
          const order = position < 0 ? '' : String(position);
          if (card.style.order !== order) card.style.order = order;
        });
        const hidden = chosen.length === 0;
        if (root.hidden !== hidden) root.hidden = hidden;
      });
    }

    window.cmCartUpsells = { render };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => render(), { once: true });
    else render();
  })();
  } catch(e) { console.error(e); }
})();

})();
